import LegalLayout from "./LegalLayout";

const sections = [
  {
    heading: "Confidential Platform Content",
    blocks: [
      { type: "p", text: "The Delta GreenX platform contains confidential business methodologies, proprietary AI workflows, strategic operational frameworks, investor-grade commercial models, and trade-secret systems." },
    ],
  },
  {
    heading: "Strict Capture Prohibition",
    blocks: [
      { type: "p", text: "Users are strictly prohibited from creating any temporary or permanent records of any portion of the platform, including:" },
      { type: "ul", items: [
        "Recording or photographing",
        "Screen capturing or screenshots",
        "Audio recording",
        "Livestreaming",
        "Copying, mirroring, or storing",
        "Reproducing in any form",
      ]},
    ],
  },
  {
    heading: "Restricted Methods",
    blocks: [
      { type: "p", text: "This restriction applies to all methods including:" },
      { type: "ul", items: [
        "Mobile devices",
        "Desktop tools",
        "Wearable devices",
        "Browser extensions",
        "Meeting software",
        "Handwritten replication",
        "External cameras",
        "Remote desktop environments",
        "Third-party capture systems",
      ]},
    ],
  },
  {
    heading: "Forensic Detection Systems",
    blocks: [
      { type: "p", text: "Users expressly acknowledge that Delta GreenX may deploy:" },
      { type: "ul", items: [
        "Watermarking systems",
        "Session identity markers",
        "Forensic identifiers",
        "Metadata tagging",
        "Access pattern analytics",
        "Digital evidence collection systems",
      ]},
      { type: "note", text: "Each demo session is uniquely watermarked and tracked with viewer identity, fund identity, session ID, browser fingerprint, and per-session nonce. Forwarded or leaked materials can be traced back to the original viewer." },
    ],
  },
  {
    heading: "Consequences of Violation",
    blocks: [
      { type: "p", text: "Any violation may result in:" },
      { type: "ul", items: [
        "Immediate account termination",
        "Permanent blacklisting",
        "Investor disqualification",
        "Forensic investigation",
        "Emergency legal intervention",
        "Injunctive relief",
        "Civil damages",
        "Additional remedies available under applicable law",
      ]},
    ],
  },
];

export default function RecordingPolicy() {
  return (
    <LegalLayout
      title="Recording & Platform Capture Restrictions"
      eyebrow="Legal · Capture Restrictions"
      effective="May 1, 2026"
      lastUpdated="May 1, 2026"
      intro={[
        "The Delta GreenX platform contains highly confidential, trade-secret, and investor-sensitive content. To protect platform integrity, capture and reproduction in any form is strictly prohibited.",
        "By continuing to access the platform you agree not to record, capture, copy, or reproduce any portion of the system in any form.",
      ]}
      sections={sections}
      contact="legal@deltagreenx.com"
    />
  );
}
